<template>
  <div id="page-user-view">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @show_schedule_alert="show_schedule_alert" @close-sidebar="toggleDataSidebar" :data="sidebarData"/>
    <add-camera-sidebar :isSidebarActive="addNewCameraSidebar" @close-sidebar="toggleCameraSidebar" :data="cameraSidebarData" />
    <edit-camera-sidebar :isSidebarActive="addNewCameraDataSidebar" @getdata="getdata" @closeSidebar="toggleEditCameraDataSidebar" :data="sidebarEditCameraData" />
    <add-group-sidebar :isSidebarActive="addGroupDataSidebar" @getdata="getdata" @closeSidebar="toggleGroupDataSidebar" :data="sidebarGroupData" />
    <add-group-camera-sidebar :isSidebarActive="addGroupCameraDataSidebar" @getdata="getdata" @closeSidebar="toggleGroupCameraDataSidebar" :data="sidebarGroupCameraData" />

    <add-room-sidebar :isRoomSidebarActive="addRoomDataSidebar" @getdata="getdata" @closeRoomSidebar="toggleRoomDataSidebar" :data="sidebarRoomData" />
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <camera-setting-sidebar :isSettingSidebarActive="settingDataSidebar" @getdata="getdata" @closeSettingSidebar="toggleSettingDataSidebar" :data="sidebarSettingData" />
    <video-view  :setting="cameraSetting" :camera="cameraCode" :active="activeVideo"  @closeVideView="closeVideView"/>
        <location-setting-side-bar :isLocationSidebarActive="addSettingSidebar"
                               @close-sidebar="toggleLocationSettingDataSidebar" :data="locationSettingSideBarData"/>

    <vs-alert color="danger" title="Location Not Found" :active.sync="user_not_found">
      <span>Location record with id: {{ $route.params.locationId }} not found. </span>
      <span>
      </span>
    </vs-alert>
       <vs-popup fullscreen title="" :active.sync="popupActive">
    <div id="page-camera-view" >
    <iframe  width="100%" height="490" class="center" :src="reset" allowfullscreen></iframe>
  </div>
      </vs-popup>
    <div id="user-data" v-if="location" >
      <vx-card v-disable-all="!locationBilling">
      <span class="flex">
      <h4  class="mb-base">{{location.name}}</h4>
      <h5 class="ml-12 text-danger" v-if="!locationBilling">This record is disabled because of its locations’ billing problems</h5>
      </span>

        <!-- <div class="vx-row">
          <div class="vx-col" id="avatar-col">
             <div class="img-container mb-2">
              <p class="rounded w-full bg-primary text-white" @click.stop="editStudentData(location)" :data-letters="location.name[0].toUpperCase()"></p>
            </div>
          </div>
          <div class="vx-col" id="account-info-col-1">
            <table>
            <tr>
              <td>Timezone</td>
             </tr>
               <tr>
                <td>{{ location.timezone.name }}</td>
              </tr>
            </table>
           </div>
             <div class="vx-col" id="account-info-col-1">
            <table>
            <tr>
              <td>Managers</td>
             </tr>
              <tr>
              <td v-if="location.managers.length == 0">No Manager</td>
              <td v-else>
              <div  v-for="(manager, index) in location.managers" :key="index">
               <vs-chip    color="primary" >
              <vs-avatar  />
               <p  class="text-inherit"> {{ manager.fname }} {{ manager.lname }}</p>
               </vs-chip>
              </div></td>
              </tr>
            </table>
           </div>
                <div class="vx-col flex-1" id="account-info-col-1">
            <table>
            <tr>
              <td>Rooms</td>
             </tr>
              <tr>
              <td v-if="location.rooms.length == 0">No Rooms</td>
              <td v-else>
              <div  v-for="(room, index) in location.rooms" :key="index">
               <vs-chip    color="primary" >
               <p  class="text-inherit"> {{ room.name }}</p>
               </vs-chip>
              </div>
                <vs-button @click="addNewRoom(location)" size="small"><feather-icon icon="PlusIcon" svgClasses="h-2 w-2" />
               <span>Add New</span></vs-button></td>
              </tr>
            </table>
           </div>
     
             <div class="vx-col " id="account-info-col-2">
            <table>
            <tr>
            <td>Schedule</td>
             </tr>
             <tr>
              <td v-if="location.schedule">
                   <div v-for="scheduledate in location.schedule.scheduledates" :key="scheduledate.id">
                <span>
                {{ scheduledate.day + ' : '}}
                {{ scheduledate.start_time | formatTime }}   {{ scheduledate.end_time | formatTime }}
                </span>
              </div>
              </td>
              <td v-else>No Schedule</td>
            </tr>
            <tr v-if="location.schedule">
              <td><vs-button size="small" @click.stop="confirmApplySchedule(location)" >Apply to All Cameras</vs-button></td>
            </tr>
            </table>
          </div>

        </div>
        <div class="vx-row">
          <div class="vx-col" id="avatar-col">
 
          </div>
          <div class="vx-col" id="account-info-col-1">
            <table>
            <tr>
              <td>Timezone</td>
             </tr>
               <tr>
                <td>{{ location.timezone.name }}</td>
              </tr>
            </table>
            <div class="vx-col" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Middle Name</td>
                <td>sdgsdgsdg</td>
              </tr>
               <tr>
                <td class="font-semibold">Middle Name</td>
                <td >sdfsdfd</td>
              </tr>
              <tr>
                <td class="font-semibold">Status</td>
                <td >Enabled</td>
              </tr>
            </table>
          </div>
           </div>

          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4"  @click="editData(location)">Edit</vs-button>
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord(location)">Delete</vs-button>
          </div>
        </div> -->
  
        <!-- Avatar -->
        <div class="vx-row" v-disable-all="!locationBilling">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
              <div class="img-container mb-2">
              <p class="rounded w-full bg-primary text-white" :data-letters="location.name[0].toUpperCase()"></p>
            </div>
          </div>
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td  class="font-semibold">Name</td>
                <td>{{location.name}}</td>
              </tr>
               <tr  >
                <td class="font-semibold">Address</td>
                <td v-if="location.address">{{location.address}}</td>
                <td v-else>N/A</td>
              </tr>
              <tr>
                <td class="font-semibold">Timezone</td>
                <td >{{location.timezone.name}}</td>
              </tr>

              <tr>
              <td class="font-semibold">Camera Groups</td>
              <td v-if="location.groups.length == 0">No groups</td>
              <td v-else>
                <table id="customers" v-if="location.groups.length > 0">
                <thead>
                  <tr  class="bg-primary">
               <th>Groups</th>
               <th>Cameras</th>
                </tr>
                </thead>
               <tbody>
                 <tr  v-for="(group, index) in location.groups" :key="index">
                <td>
                  <div class="flex justify-between">
                  <span class="font-normal">{{ group.name }} </span>
                  <span   @click="deleteConfirmGroup(group)" class="text-danger cursor-pointer">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                </span>
                </div>

                <!-- <vs-chip @click="deleteConfirmGroup(group)" color="primary"  closable>{{ group.name }}</vs-chip></td> -->
                <td>
                <div class="flex">
                <span v-if="group.cameras.length > 0">
                     <vs-chip  color="primary" close-icon="close" v-for="(camera, cindex) in group.cameras" :key="cindex">
                      <vs-avatar icon-pack="feather" icon="icon-camera" :color="camera.color_code" />
                      {{camera.name}}
                      </vs-chip>
                  </span>
                </div>
                 <vs-tooltip text="Assign Cameras" style="width: 16px !important">
                 <span  @click="addNewCameraGroup(group,location.cameras)"  class="text-primary cursor-pointer">
                  <!-- <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/> -->
                   <i class="material-icons ml-1" style="font-size: 14px !important">add_a_photo</i>
                </span>
                 </vs-tooltip>

                    <!-- <vs-button icon="add_a_photo" @click.native="addNewCameraGroup(group,location.cameras)" size="small" style="height:20px !important;margin: auto" ></vs-button> -->

                </td>
              </tr>
               </tbody>
               </table>
              </td>
              </tr>
               <tr>
                <td></td>
                <td>  
                  <vs-button @click.native="addNewGroup(location)" size="small"><feather-icon icon="PlusIcon" svgClasses="h-2 w-2" />
               <span>Add New Camera Group</span></vs-button></td>
              </tr>
              <!-- <tr>
                <td class="font-semibold">Rooms</td>
                 <td v-if="location.rooms.length == 0">No Rooms</td>
              <td v-else>
              <div  v-for="(room, index) in location.rooms" :key="index">
               <vs-chip  @click="confirmDeleteRoom(room)"  color="primary" closable>
               <p  class="text-inherit"> {{ room.name }}</p>
               </vs-chip>
              </div>
              </td>
              </tr>
              <tr>
                <td></td>
                <td>  
                  <vs-button @click.native="addNewRoom(location)" size="small"><feather-icon icon="PlusIcon" svgClasses="h-2 w-2" />
               <span>Add New</span></vs-button></td>
              </tr>
              <tr>
                <td></td>
              <td>
                <table id="customers" v-if="RoomChart.length > 0">
                <tr  class="bg-primary">
               <th>Room</th>
               <th>Student</th>
                </tr>
              <tr v-for="(single, indexx) in RoomChart" :key="indexx" >
              <td > <vs-chip   @click="confirmDeleteTableRoom(single)"  color="primary" closable>{{single.room.name}} </vs-chip></td>
              <td>{{single.students_count}}</td>
              </tr>
               </table>
              </td>
              </tr> -->
               <!-- <tr>
                <td class="font-semibold">Groups</td>
                 <td v-if="location.groups.length == 0">No groups</td>
              <td v-else>
              <div  v-for="(group, index) in location.groups" :key="index">
               <vs-chip @click="deleteConfirmGroup(group)" color="primary"  closable>
               <p  class="text-inherit"> {{ group.name }}</p>
               </vs-chip>
              </div>
              </td>
              </tr>
              <tr>
                <td></td>
                <td>  
                  <vs-button @click.native="addNewGroup(location)" size="small"><feather-icon icon="PlusIcon" svgClasses="h-2 w-2" />
               <span>Add New</span></vs-button></td>
              </tr> -->
              <tr>
                <td class="font-semibold">Managers</td>
              <td v-if="location.managers.length == 0">No Manager</td>
              <td v-else>
              <div  v-for="(manager, index) in location.managers" :key="index">
               <vs-chip    color="primary" >
              <vs-avatar  />
               <p  class="text-inherit"> {{ manager.fname }} {{ manager.lname }}</p>
               </vs-chip>
              </div></td>
              </tr>
            </table>
          </div>
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Email</td>
                <td v-if="location.email">{{location.email}}</td>
                <td v-else>N/A</td>
              </tr>
              <tr >
                <td class="font-semibold">Phone</td>
                <td v-if="location.phone">{{location.phone}}</td>
                <td v-else>N/A</td>
                
              </tr>

                <tr>
                <td class="font-semibold">Longitude</td>
                 <td v-if="location.longitude">{{location.longitude}}</td>
                  <td v-else>N/A</td>
              </tr>
              <tr>
                <td class="font-semibold">Latitude</td>
                <td v-if="location.latitude">{{location.latitude}}</td>
                <td v-else>N/A</td>
              </tr>
               <tr>
                <td class="font-semibold">Map URL</td>
                <td v-if="location.pin_url"><a  :href="location.pin_url" target="_blank" rel="noopener noreferrer">{{location.pin_url}}</a></td>
                <td v-else>N/A</td>
              </tr>
               <tr>
                <td class="font-semibold">Schedule</td>
                <td v-if="location.schedule">
                   <div v-for="scheduledate in locationSchedule" :key="scheduledate.id">
                <span>
                {{ scheduledate.day + ' : '}}
                {{ scheduledate.start_time | formatTime }}   {{ scheduledate.end_time | formatTime }}
                </span>
              </div>
              </td>
              <td v-else>No Schedule</td>
              </tr>
              <tr v-if="location.schedule && location.cameras && location.cameras.length > 0">
              <td></td>
              <td>
                <vs-alert color="danger" :active.sync="scheduleAlert" closable icon-pack="feather" close-icon="icon-x" class="mb-5 schedule_alert">
                     <p class="font-small text-sm" style="word-break: normal">This location's schedule has recently changed. Click below button to copy location's schedule to all its cameras.</p>
                 </vs-alert>
                <!-- <small class="text-danger" v-if="scheduleAlert">This location's schedule has recently changed. Click below button to copy location's schedule to all its cameras.</small><br> -->
                <vs-button size="small" @click.native="confirmApplySchedule(location)" >Apply to All Cameras</vs-button>
              
              </td>
              </tr>
              <!-- <tr v-if="location.is_signup">
              <td class="font-semibold">Signup Code</td>
              <td>{{location.signup_code}}  <vs-button size="small" class="ml-10" @click="ResetSignup(location.id)">Reset code</vs-button>
               </td>
              </tr> -->
              <tr v-if="$GlobalFunction.checkPermission('manage_location_billing')">
                 <td class="font-semibold" v-if="$GlobalFunction.checkPermission('manage_location_billing')">Billing</td>
                 <td>
                    <vs-tooltip :text="billing(location.billing)" position="left">
                    <span v-if="locationBilling" class="flex">
                      <small class="flex-inline text-success mt-1">Good Standing</small>
                      <feather-icon  icon="SlashIcon" @click="changeBilling(location.id,location.billing)" style="cursor:pointer" class="inline-flex text-danger ml-1" svgClasses="h-6 w-6"/>
                    </span>  
                    <span v-else class="flex">
                    <small class="flex-inline text-danger  mt-1">Defaulted</small>
                    <feather-icon  icon="RotateCwIcon" @click="changeBilling(location.id,location.billing)" style="cursor:pointer" class="inline-flex text-success ml-1" svgClasses="h-6 w-6"/>
                     </span> 
 
                     <!-- <h3 @click="changeBilling(location.id,location.billing)" class="text-primary" style="cursor:pointer">&#10003;</h3> -->
                     <!-- <vs-switch v-model="location.billing" @input="changeBilling(location.id,location.billing)"></vs-switch> -->
                   </vs-tooltip>    
                </td>
              </tr>
                <tr v-if="!locationBilling">
                 <td class="font-semibold">ACH Details</td>
                 <td >
                      <p class="mb-2" v-if="location.location_billing_request">{{location.location_billing_request.value}}</p> 
                      <vs-textarea label="Please provide the billing details" maxlength="150" v-model="billingDetails" width="240px"/>
                      <span @click="ReActivation(location.id)" class="cursor-pointer bg-primary vs-component vs-button vs-button-primary vs-button-filled small float-right">Submit</span>
                      <!-- <feather-icon icon="SendIcon" @click="ReActivation(location.id)" style="cursor:pointer" class=" text-primary ml-2" svgClasses="h-6 w-6"/> -->

                       <!-- <vs-button size="small" @click="ReActivation(location.id)" class="ml-12">Request re-activation</vs-button> -->
                       <!-- <span  style="cursor:pointer" class="text-primary ml-12"><small @click="ReActivation(location.id)">Request re-activation</small></span> -->
                </td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4"  @click.native="editData(location)">Edit</vs-button>
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click.native="confirmDeleteRecord(location)">Delete</vs-button>
              <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer" v-if="location.billing">
                  <div>
                    <feather-icon icon="MoreVerticalIcon" @click.stop="" svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" />
                  </div>
                <vs-dropdown-menu>
                <vs-dropdown-item @click="locationSettingData(location)">
                <span class="flex items-center" >
                  <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Settings</span>
                </span>
                </vs-dropdown-item>
                <vs-dropdown-item  @click="genQr(location.id)" >
                <span class="flex items-center">
                  <feather-icon icon="CodepenIcon" svgClasses="h-4 w-4" class="mr-2"  />
                  <!-- <span>{{ $t('common.qr_code') }}</span> -->
                  <span>Get Registration Form</span>
                </span>
              </vs-dropdown-item>

                </vs-dropdown-menu>
                </vs-dropdown>
          </div>
        </div>
      </vx-card>
      </div>
      <span class="flex flex-wrap-reverse items-center">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container mt-5"  v-if="location.cameras" v-disable-all="!locationBilling">
       <h3 class="ml-5">Cameras</h3>
          <!-- ADD NEW -->
         <vs-button v-if="location && role" @click.native="addLocationSetting(location)" color="primary" type="filled" class="ml-2 customizer-st-btn" icon-pack="feather" icon="icon-settings" />
          <!-- <vs-button v-if="location" color="primary" class="ml-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" type="border" icon="add" @click="addLocationSetting(location)" >Add Setting</vs-button> -->
          <vs-button color="primary" class="ml-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" type="border" icon="add" @click.native="addCameraData(location)" >Add New</vs-button>
          <!-- <div class="btn-add-new p-3 ml-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addCameraData(location)" >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary"  >Add New</span>
          </div> -->
        </div>
        </span>
       <div v-if="location.cameras" v-disable-all="!locationBilling">
        <p v-if="location.cameras.length==0" class="ml-5 text-left mt-5">No camera associate to this location</p>
       <div   v-if="location.cameras.length>0" class="data-list-container p-6 pt-0" >  
       <vs-table ref="table"  :data="location.cameras" > 
        <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="code">Code</vs-th>
        <vs-th sort-key="location">Camera ID</vs-th>
        <vs-th sort-key="color_code">Color</vs-th>
        <vs-th sort-key="color_code">Groups</vs-th>
      </template>
       <template slot-scope="{data}" >
        <draggable tag="tbody" class="cursor-move" v-model="location.cameras" @end="updateItemOrder" >
          <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
              <vs-td>
                <p class="product-name font-medium ">{{ tr.name }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium ">{{ tr.code }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium ">{{ tr.camera_id }}</p>
              </vs-td>
               <vs-td>
                <ul>
                  <span  @click="PlayCamera(tr.id,tr.code,tr.location_setting.location_camera_setting,tr.location_setting.id)"><li  :style="{background: tr.color_code}" class="w-4 h-4 round" /></span>
                </ul>
              </vs-td>
              <vs-td>
                  <vs-chip v-for="group in tr.groups" :key="group.id">{{group.name}}</vs-chip>
              </vs-td>
                <vs-td class="whitespace-no-wrap">
                 <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer " >
                  <div >
                    <feather-icon svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" icon="MoreVerticalIcon" @click.stop=""></feather-icon>
                  </div>
                  <vs-dropdown-menu>
                  <vs-dropdown-item @click="editCamera(tr)">
                <span class="flex items-center" >
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span> Edit </span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="confirmDeleteCameraRecord(tr)">
                <span class="flex items-center" >
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>Delete</span>
                </span>
                </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
                </vs-td>
            </vs-tr>
         </draggable>
        </template>
    </vs-table>
     <vs-popup class="holamundo" title=" " :active.sync="QRpopupActive">
             <vs-row>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <vue-qrcode :value="Qr_link" :width="300" ref="QR" />
              </vs-col>
               <vs-col  vs-offset="2" vs-w="6" > 
                  <vs-input v-model="Qr_link" class="w-full" disabled></vs-input>
              </vs-col>
              <vs-col vs-w="4"> 
                   <vs-button size="small" class="mt-2 ml-1" 
                                v-clipboard:copy="Qr_link"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onError">Copy</vs-button>
              </vs-col>
              <vs-col  vs-offset="2" vs-w="6" > 
                  <vs-input v-model="qr_code" class="w-full" disabled></vs-input>
                  <!-- <vs-button size="small"><small @click="ResetSignup">Reset code</small></vs-button> -->
                                         

              </vs-col>
              <vs-col vs-w="4" class="mb-base"> 
                   <vs-button size="small" class="mt-2 ml-1" 
                                v-clipboard:copy="qr_code"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onError">Copy</vs-button>
              </vs-col>
               </vs-row>
              <vs-row >
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <!-- <vs-button class="ml-10">Print</vs-button> -->
              <vs-button  @click.native="genQr(dataId)">Reset code</vs-button>
              <vs-button class="ml-10" @click.native="downloadQR()">Download</vs-button>

              </vs-col>
               </vs-row>
  </vs-popup>
    </div> 
    </div>
    </div>
</template>
<script>
import moment from 'moment'
import {SINGLE_LOCATION, REMOVE_LOCATION, REMOVE_CAMERA, APPLLY_SCHEDULE_TO_CAMERAS, PLAY_CAMERA, REMOVE_LOCATION_ROOM, SINGLE_LOCATION_ROOM_CHART, SAVE_CAMERA_ORDER, UPDATE_LOCATION_SIGNUP_CODE,UPDATE_LOCATION_BILLING,UPDATE_LOCATION_BILLING_REQUEST_SETTING,GENERATE_LOCATION_QR,REMOVE_LOCATION_GROUP} from '@/graphql'
import DataViewSidebar from './addSidebarView.vue'
import AddCameraSiderbar from './addCameraSidebar'
import EditCameraSidebar from '../cameras/addSidebarView'
import AddRoomSidebar from './addRoomSidebar.vue'
import AddGroupSidebar from './addGroupSidebar.vue'
import AddGroupCameraSidebar from './addGroupCameraSidebar.vue'
import cameraSettingSidebar from './cameraSettingSidebar.vue'
import VueApexCharts from 'vue-apexcharts'
import draggable from 'vuedraggable'
import VideoView from '../../components/VideoView.vue'
import LocationSettingSideBar from './locationSettingSidebar.vue'
import VueQrcode from 'vue-qrcode'


export default {
  name: 'Location.vue',
  components: {
    DataViewSidebar,
    'add-camera-sidebar': AddCameraSiderbar,
    'edit-camera-sidebar': EditCameraSidebar,
    'add-room-sidebar': AddRoomSidebar,
    'add-group-sidebar': AddGroupSidebar,
    'add-group-camera-sidebar': AddGroupCameraSidebar,
    'camera-setting-sidebar':cameraSettingSidebar,
    VueApexCharts,
    draggable,
    LocationSettingSideBar,
     'video-view':VideoView,
      VueQrcode
  },
  data: () => ({
    user_not_found: false,
    location:'',
    addNewDataSidebar: false,
    addNewCameraDataSidebar: false,
    addRoomDataSidebar: false,
    addGroupDataSidebar: false,
    settingDataSidebar: false,
    addSettingSidebar: false,
    addGroupCameraDataSidebar:false,
    locationSettingSideBarData: {},
    sidebarData: {},
    DeletedItem:'',
    addNewCameraSidebar:false,
    cameraSidebarData: {},
    sidebarEditCameraData:{},
    sidebarRoomData:{},
    sidebarSettingData:{},
    sidebarGroupData:{},
    sidebarGroupCameraData:{},
    IframeSrc:'',
    popupActive: false,
    DeleteID:'',
    RoomChart:[],
    series: [44, 55, 67, 83],
    themeColors :['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
    dragging: false,
    billingDetails:null,
    cameraSetting:[],
    cameraCode:null,
    activeVideo:false,
    showScheduleAlert:true,
     QRpopupActive: false,
      qr_link:'google.com',
      qr_code:null,
      dataId:null,
  }),
  filters: {
    formatTime (value) {
      if (value) {
        return moment(String(value), 'h:mm A').format('h:mm A')
      }
    }
  },
  computed: {
    Qr_link () {
      return this.qr_link
    },
    locationBilling(){
      if(this.location){
           return this.location.billing
      }
    },
    locationSchedule(){
      var schedule=[];
      if(this.location && this.location.schedule && this.location.schedule.scheduledates.length > 0){
       this.location.schedule.scheduledates.forEach(element => {
         if(element.day==='Monday'){
            schedule.push(element)
         }
       });
       this.location.schedule.scheduledates.forEach(element => {
         if(element.day==='Tuesday'){
            schedule.push(element)
         }
       });
       this.location.schedule.scheduledates.forEach(element => {
         if(element.day==='Wednesday'){
            schedule.push(element)
         }
       });
       this.location.schedule.scheduledates.forEach(element => {
         if(element.day==='Thursday'){
            schedule.push(element)
         }
       });
       this.location.schedule.scheduledates.forEach(element => {
         if(element.day==='Friday'){
            schedule.push(element)
         }
       });
        this.location.schedule.scheduledates.forEach(element => {
         if(element.day==='Saturday'){
            schedule.push(element)
         }
       });
        this.location.schedule.scheduledates.forEach(element => {
         if(element.day==='Sunday'){
            schedule.push(element)
         }
       });
      }
       return schedule;
    },
    scheduleAlert:{
    get: function () {
       if(this.location){
         if(this.location.schedule){
            const locationTime = this.location.schedule.scheduledates[0].updated_at
            if(this.location.cameras.length > 0){
              var dateIsAfter = false
              for (let index = 0; index < this.location.cameras.length; index++) {
                const camera = this.location.cameras[index];
                if(camera.schedule && camera.schedule.scheduledates){
                dateIsAfter = moment(moment(camera.schedule.scheduledates[0].updated_at)).isAfter(locationTime);
                // console.log(dateIsAfter)
                if(dateIsAfter == false && this.showScheduleAlert == true){
                    return 'true'
                }
              }
              }
               return false
          }
          else{
               return false
          }
         }     
      }
    },
     set: function (newValue) {
       this.showScheduleAlert = newValue
       localStorage.setItem('schedule_alert',false)
    }
    },
    role(){
         let role = JSON.parse(localStorage.getItem('userRoles'))

             console.log(role[0].name)
             if(role[0].name==='admin'){
               return true
             }
             else{
               false
             }
    },
    reset () {
      if (this.popupActive) {
        return this.IframeSrc
      }
      if (!this.popupActive) {
        
      }
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    chartSeries () {
      return this.series
    },
    chartOptions () {
      return {
        colors: this.themeColors,
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                fontSize: '22px'
              },
              value: {
                fontSize: '16px'
              },
              total: {
                show: true,
                label: 'Total',
                formatter (w) {
                  // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                  return 249
                }
              }
            }
          }
        },
        labels: this.labels
      }
    }

  },
  methods: {
            onCopy () {
      this.$vs.notify({
        title: 'Success',
        text: 'Text copied successfully',
        color: 'success',
        iconPack: 'feather',
        position: 'top-center',
        icon:'icon-check-circle'
      })
    },
    onError () {
      this.$vs.notify({
        title: 'Failed',
        text: 'Error in copying text',
        color: 'danger',
        iconPack: 'feather',
        position: 'top-center',
        icon:'icon-alert-circle'
      })
    },
    downloadQR () {
      const img = this.$refs.QR.$el
      const a = document.createElement('a')
      a.href = img.src
      a.download = 'QR_CODE'
      a.click()
      this.QRpopupActive = false
    },
        genQr (id) {
      this.dataId=id
      var qr_code_number = "L"+Math.random().toString().slice(2, 10)
      const path = '/register/'
      const list = []
      list.push(id)
      this.qr_link = process.env.VUE_APP_APP_LINK + path
      this.$apollo
        .mutate({
          mutation: GENERATE_LOCATION_QR,
          variables: {
            code:qr_code_number,
            link:this.qr_link,
            location_id:list
          }
        })
        .then(response => {
          if (response) {
            this.qr_link = this.qr_link+response.data.generateLocationQr.color
            this.qr_code = response.data.generateLocationQr.color
            this.QRpopupActive = true
          }
        }).catch(error => {
          console.log(error)
        })
    },
    show_schedule_alert(){
      this.showScheduleAlert=true
      localStorage.setItem('schedule_alert',true)
    },
    toggleLocationSettingDataSidebar (val = false) {
      this.addSettingSidebar = val
    },
     locationSettingData (data) {
      this.locationSettingSideBarData = data
      this.toggleLocationSettingDataSidebar(true)
    },
    ReActivation(id){
       if(this.billingDetails){
        this.$apollo
        .mutate({
          mutation: UPDATE_LOCATION_BILLING_REQUEST_SETTING,
          variables: {
            id,
            billing:this.billingDetails
          }
        })
        .then(response => {
          this.get()
          this.billingDetails=null
          if (response.data.updateLocationBillingRequestSetting.status === 'Success') {
            this.StatusSuccess(response.data.updateLocationBillingRequestSetting.message, response.data.updateLocationBillingRequestSetting.color)
          }
        }).catch(error => {
          console.log(error)
        })
         
       }
    },
    changeBilling(id,billing){
      billing=!billing
       this.location.billing=billing
        this.$apollo
        .mutate({
          mutation: UPDATE_LOCATION_BILLING,
          variables: {
            id,
            billing
          }
        })
        .then(response => {
          if (response.data.updateLocationBilling.status === 'Success') {
            this.get()
            this.StatusSuccess(response.data.updateLocationBilling.message, response.data.updateLocationBilling.color)
            
            // setTimeout(() => {  this.$router.go(this.$router.currentRoute) }, 2000);
          }
        }).catch(error => {
          console.log(error)
        })
    
    },
    billing(text){
        if(text){
           return "Block location for billing default"
        }
        else{
             return "Restore location for good standing"
        }
    },
    ResetSignup (id) {
      const code = "L"+Math.random().toString().slice(2, 10)
      this.location.signup_code = code
      this.$apollo
        .mutate({
          mutation: UPDATE_LOCATION_SIGNUP_CODE,
          variables: {
            id,
            code
          }
        })
        .then(response => {
          if (response.data.updateLocationSignupCode.status === 'Success') {
            this.StatusSuccess(response.data.updateLocationSignupCode.message, response.data.updateLocationSignupCode.color)
          }
        }).catch(error => {
          console.log(error)
        })

    },
    updateItemOrder () {
      const items = this.location.cameras.map(function (item, index) {
        return { item: item.id, order: index + 1 }
      })
      //  setTimeout(function() {
      this.$apollo
        .mutate({
          mutation: SAVE_CAMERA_ORDER,
          variables: {
            cameras: items
          }
        })
        .then(response => {
          if (response) {
            // console.log(response)
          }
        }).catch(error => {
          console.log(error)
        })

      // }, 3000);

    },
    deleteConfirmGroup(group){
      this.DeleteID = group.id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${group.name}"`,
        accept: this.removeGroup,
        acceptText: 'Delete'
      })
    },
    confirmDeleteTableRoom (room) {
      this.DeleteID = room.room.id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${room.room.name}"`,
        accept: this.removeRoom,
        acceptText: 'Delete'
      })
    },
    confirmDeleteRoom  (room) {
      this.DeleteID = room.id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${room.name}"`,
        accept: this.removeRoom,
        acceptText: 'Delete'
      })
    },
    removeGroup(){
      this.$apollo
        .mutate({
          mutation: REMOVE_LOCATION_GROUP,
          variables: {
            group_id: this.DeleteID
          }
        })
        .then(response => {
          this.get()
          if (response.data.deleteLocationGroup.status == 'Success') {
            this.StatusSuccess(response.data.deleteLocationGroup.message, response.data.deleteLocationGroup.color)
          }
        }).catch(error => {
          console.log(error)
        })
    },
    removeRoom () {
      this.$apollo
        .mutate({
          mutation: REMOVE_LOCATION_ROOM,
          variables: {
            room_id: this.DeleteID
          }
        })
        .then(response => {
          this.get()
          if (response.data.deleteLocationRoom.status == 'Success') {
            this.StatusSuccess(response.data.deleteLocationRoom.message, response.data.deleteLocationRoom.color)
          }
        }).catch(error => {
          console.log(error)
        })
    },
    PlayCamera (id,code,settings,location) {
      const camera = {id:id,code:code,location:location}
      this.cameraSetting=settings,
      this.cameraCode=camera
      this.activeVideo=true
    },
      closeVideView(){
      this.activeVideo=false
      this.cameraSetting=[]
      this.cameraCode={}
   },
    confirmApplySchedule (location) {
      this.DeletedItem = location
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirm Action',
        text: `You are about to Apply "${location.name} " Schedule to all its Cameras`,
        accept: this.applySchedule,
        acceptText: 'Yes'
      })
    },
    applySchedule () {
      this.$apollo
        .mutate({
          mutation: APPLLY_SCHEDULE_TO_CAMERAS,
          variables: {
            id: this.DeletedItem.id,
            schedule_id:this.DeletedItem.schedule.id
          }
        })
        .then((response) => {
          this.get()
          this.StatusSuccess(response.data.applyScheduleToCameras.message, response.data.applyScheduleToCameras.color)
        })
    },
    getdata (value) {
      if (value) {
        this.get()
      }
    },
    toggleEditCameraDataSidebar (val = false) {
      this.addNewCameraDataSidebar = val
    },
     toggleGroupDataSidebar (val = false) {
      this.addGroupDataSidebar = val
    },
    toggleGroupCameraDataSidebar (val = false) {
      this.addGroupCameraDataSidebar = val
    },
    toggleRoomDataSidebar (val = false) {
      this.addRoomDataSidebar = val
    },
     toggleSettingDataSidebar (val = false) {
      this.settingDataSidebar = val
    },
    editCamera (data) {
      this.sidebarEditCameraData = data
      this.toggleEditCameraDataSidebar(true)
    },
    addCameraData (data) {
      this.cameraSidebarData = data
      this.toggleCameraSidebar(true)
    },
    addNewRoom (data) {
      this.sidebarRoomData = data
      this.toggleRoomDataSidebar(true)
    },
     addNewGroup (data) {
      this.sidebarGroupData = data
      this.toggleGroupDataSidebar(true)
    },
    addNewCameraGroup (group,locationCameras) {
      var data = {"group":group,"cameras":locationCameras}
      this.sidebarGroupCameraData = data
      this.toggleGroupCameraDataSidebar(true)
    },
     addLocationSetting (data) {
      this.sidebarSettingData = data
      this.toggleSettingDataSidebar(true)
    },
    toggleCameraSidebar (val = false) {
      this.addNewCameraSidebar = val
      if (!val) {
        this.get()
      }
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
      if (!val) {
        this.get()
      }
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    editCameraData (data) {
      this.sidebarCameraData = data
      this.toggleCameraSidebar(true)
    },
    confirmDeleteCameraRecord (camera) {
      this.DeletedItem = camera
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${camera.name} "`,
        accept: this.deleteDataCamera,
        acceptText: 'Delete'
      })
    },
    deleteDataCamera () {
      this.$apollo
        .mutate({
          mutation: REMOVE_CAMERA,
          variables: {
            id:  this.DeletedItem.id,
            schedule_id:this.DeletedItem.schedule.id
          }
        })
        .then(response => {
          this.get()
          if (response.data.deleteCamera.status == 'Success') {
            this.StatusSuccess(response.data.deleteCamera.message, response.data.deleteCamera.color)
          } else {
            this.StatusSuccess(response.data.deleteCamera.message, response.data.deleteCamera.color)
          }
        }).catch(error => {
          console.log(error)
        })
    },

    confirmDeleteRecord (location) {
      this.DeletedItem = location
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${location.name}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    deleteData () {
      this.$apollo
        .mutate({
          mutation: REMOVE_LOCATION,
          variables: {
            id: this.DeletedItem.id,
            schedule_id:this.DeletedItem.schedule.id
          }
        })
        .then(response => {
          this.get()
          if (response.data.deleteLocation.status == 'Success') {
            this.StatusSuccess(response.data.deleteLocation.message, response.data.deleteLocation.color)
            this.$router.push({ path: '/locations' })

          } else {
            this.StatusSuccess(response.data.deleteLocation.message, response.data.deleteLocation.color)
          }
        }).catch(error => {
          console.log(error)
        })
      // this.$store.dispatch('dataList/removeLocation', id).catch(err => { console.error(err) })
    },  
    StatusSuccess (status, color) {
      this.$vs.notify({
        title: 'Location',
        text: status,
        color,
        position: 'top-right'
      })

    },
    get () {
      this.$apollo
        .mutate({
          mutation: SINGLE_LOCATION,
          variables: {
            id: this.$route.params.locationId
          }
        })
        .then(response => {
          console.log(response)
          this.location = response.data.location
          // const cameras_array = response.data.location.cameras
          // const rooms = []
          // for (let index = 0; index < cameras_array.length; index++) {
          //   if (cameras_array[index].room) {
          //     rooms.push(cameras_array[index].room)
          //   }
          // }
          // this.rooms = Object.values(rooms.reduce((acc, cur) => Object.assign(acc, {[cur.id]:cur}), {}))         
        }).catch(error => {
          console.log(error)
        })
      this.$apollo
        .mutate({
          mutation: SINGLE_LOCATION_ROOM_CHART,
          variables: {
            id: this.$route.params.locationId
          }
        })
        .then(response => {
          this.RoomChart = response.data.SingleLocationRoomChart
          // const cameras_array = response.data.location.cameras
          // const rooms = []
          // for (let index = 0; index < cameras_array.length; index++) {
          //   if (cameras_array[index].room) {
          //     rooms.push(cameras_array[index].room)
          //   }
          // }
          // this.rooms = Object.values(rooms.reduce((acc, cur) => Object.assign(acc, {[cur.id]:cur}), {}))         
        }).catch(error => {
          console.log(error)
        })

    }
  },
  created () {
    if(localStorage.getItem('schedule_alert')){
        this.showScheduleAlert = JSON.parse(localStorage.getItem('schedule_alert'))
    }
    this.img_cdn = process.env.VUE_APP_IMAGES_CDN_LINK
    this.lng = process.env.VUE_APP_I18N_LOCALE
    this.get()
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }


  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

  #demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
  }
}

#avatar-col {
  width: 10rem;
}


// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }


  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

  #demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
  }
}

#demo-basic-card {
  margin-top: 1.5rem!important;
}
[data-letters]:before {
  content:attr(data-letters);
  display:block;
  border-radius: .25rem !important;
  font-size:100px;
  width: 100% !important;
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
  text-transform: none;
  text-decoration: none;
  height:110px;
  line-height:110px;
  text-align:center;
}
 [data-lettersuser]:before {
  content:attr(data-lettersuser);
   }
  .studentuserdot{
  display:inline-block;
  font-size:50px;
  width:80px;
  height:80px;
  line-height:80px;
  text-align:center;
  border-radius:50%;
  vertical-align:middle;
  margin-right:1em;
  margin-left: 100px;
  margin-bottom: 30px;
  }
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }

</style>
<style>
#customers {
  border-collapse: collapse;
  width: 100%;
}

#customers td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}

#customers tr:nth-child(even){background-color: #f2f2f2;}

#customers tr:hover {background-color: #ddd;}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  color: white;
}
  /* .customizer-st-btn .vs-icon {
    animation: spin 1.5s linear infinite;
  } */
</style>
<style>
    .sendspan {
        float: right;
        margin-right: 40px;
        margin-top: -40px;
        position: relative;
        z-index: 2;
    }
    .sendbutton{
    padding: 10px;
    display: inline;
    border-radius: 2px;
    font-family: "Arial";
    border: 0;
    margin: 0 10px;
    background: red;
    font-size: 15px;
    line-height: 15px;
    color: white;
    width: auto;
    height: auto;
    box-sizing: content-box;
}
</style>